module.exports = __webpack_public_path__ + "static/scrabblista-mobile-1.0f6425a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/project/scrabblista/img/scrabblista-mobile-1.png
// module id = 625
// module chunks = 230197332751855